import {useEffect,useRef,useState} from 'react';
import {analyticsFetch,useAnalyticsPolling} from './analyticsPolling';

export default function useCampaignSnapshot(campaignId,initial={}) {
  const [snapshot,setSnapshot]=useState(initial),[error,setError]=useState('');const request=useRef(null);
  const refresh=async () => {
    request.current?.abort();const controller=new AbortController();request.current=controller;
    try {
      const response=await analyticsFetch(`/api/v1/campaigns/${campaignId}/analytics_snapshot`,{signal:controller.signal,headers:{Accept:'application/json'}});
      const result=await response.json();if (!response.ok) throw new Error(result.error || 'Campaign analytics is temporarily unavailable.');
      if (!controller.signal.aborted) {setSnapshot(result);setError('');}
    } catch (failure) {if (failure.name!=='AbortError') setError(failure.message);}
  };
  useAnalyticsPolling(refresh);
  useEffect(() => () => request.current?.abort(),[]);
  return {snapshot,error,refresh,setSnapshot};
}
